import { render, staticRenderFns } from "./LgFinderPageUsuario.vue?vue&type=template&id=10c067f1"
import script from "./LgFinderPageUsuario.vue?vue&type=script&lang=js"
export * from "./LgFinderPageUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports